import React from 'react'
import "./SingleCounter.css"

function SingleCounter() {
  return (
    <div className="card">
      <img src="./img/counter.png" alt="" />
      <h3>15+</h3>
      <p>Teachers</p>
    </div>  )
}

export default SingleCounter